import { http } from 'http';

export default {
  updateElement: data =>
    http.put(
      `/cms/es-ES/templates/${data.templateName}/patterns/${data.patternName}/elements/${data.elementName}`,
      data.body,
      {
        headers: {
          appId: data.appId,
          partnerId: data.partnerId || 0
        }
      }
    )
};
